var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22.5078C4.92487 22.5078 0 17.5829 0 11.5078C0 5.43268 4.92487 0.507812 11 0.507812C17.0751 0.507812 22 5.43268 22 11.5078C22 17.5829 17.0751 22.5078 11 22.5078ZM11 20.5078C15.9706 20.5078 20 16.4784 20 11.5078C20 6.53725 15.9706 2.50781 11 2.50781C6.02944 2.50781 2 6.53725 2 11.5078C2 16.4784 6.02944 20.5078 11 20.5078ZM7.70711 16.2149L11 12.922L14.2929 16.2149L15.7071 14.8007L12.4142 11.5078L15.7071 8.21492L14.2929 6.80071L11 10.0936L7.70711 6.80071L6.29289 8.21492L9.58579 11.5078L6.29289 14.8007L7.70711 16.2149Z",
    fill: "url(#paint0_linear_2831_4373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2831_4373",
    x1: 19.3264,
    y1: 0.548098,
    x2: 1.03917,
    y2: 1.29725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF564B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E33E3E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c4e21040bd98664f55b5c437f9b9b8da.svg";
export { ForwardRef as ReactComponent };